import { MIN_PASSWORD_LENGTH } from '@repo/lib';
import * as Yup from 'yup';

// 16px text stops iOS Safari from zooming the page when an input gets focus.
export const authInputClassName = 'h-11 rounded-[10px] px-3.5 text-base';

export const authButtonClassName = 'h-12 rounded-[10px] text-[15px]';

export const authLink =
  'font-medium text-gray-900 dark:text-foreground underline underline-offset-4 decoration-gray-300 hover:decoration-gray-900';

export const passwordHint = `At least ${MIN_PASSWORD_LENGTH} characters`;

export const PASSWORD_TOO_SHORT = `Use at least ${MIN_PASSWORD_LENGTH} characters.`;

export const newPasswordField = {
  name: 'password',
  label: 'Password',
  type: 'password',
  required: true,
  autoComplete: 'new-password',
  hint: passwordHint,
};

export const newPasswordSchema = Yup.object({
  password: Yup.string().min(MIN_PASSWORD_LENGTH, PASSWORD_TOO_SHORT),
});

export const authErrorLink =
  'whitespace-nowrap font-medium text-destructive underline underline-offset-4';
